<template>
  <v-card class="d-flex flex-column ma-0 pa-0">
    <h2 class="text-center mt-4">{{title}}</h2>
    <ul class="mx-2 list_style">
      <li v-for="(item, i) in recordsCannotDelete" :key="item.subTitle" class="mt-5">
        <hr v-if="i > 0"/>
        <p class="mb-1" v-html="item.subTitle"></p>
        <ul class="list_style">
          <li v-for="motive in item.motives" :key="motive">
            <p class="mb-2"> {{ motive }}</p>
          </li>
        </ul>
      </li>
    </ul>

    <section class="d-flex justify-center">
      <v-btn
          class="secondary-button my-3"
          style="height: 40px!important; border-radius: 7.5px!important"
          height="40"
          width="60%"
          elevation="0"
          @click="close()"
      >
        Fechar
      </v-btn>
    </section>
  </v-card>
</template>

<style scoped>
.list_style {
  list-style-type: decimal;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";

export default {
  name: "RecordCannotDeleteModal",

  props: {
    title: {type: String, default: null},
    recordsCannotDelete: {type: Array, default: null},
  },

  data: () => ({}),

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
